"use client";

import { useEffect } from "react";

/* Last resort: a failure in the root layout itself, where the shell and its
   styles are not available. Kept dependency-free and inline-styled with the
   kit's tokens so it renders even when nothing else does. */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[global]", error);
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "grid",
          placeItems: "center",
          background: "#000000",
          color: "#ffffff",
          fontFamily: "Inter, system-ui, sans-serif",
        }}
      >
        <div style={{ maxWidth: "42ch", padding: 24, textAlign: "center" }}>
          <div
            style={{
              width: 44,
              height: 44,
              margin: "0 auto 12px",
              borderRadius: 100,
              background: "rgba(223, 22, 66, 0.12)",
              color: "#e75071",
              display: "grid",
              placeItems: "center",
              fontSize: 20,
              fontWeight: 700,
            }}
          >
            !
          </div>
          <p style={{ fontSize: 12, fontWeight: 700, margin: "0 0 4px" }}>The app failed to start</p>
          <p style={{ fontSize: 12, lineHeight: 1.6, color: "#9898a2", margin: "0 0 16px" }}>
            Something in the shell threw before the page could render. Reloading usually clears it.
          </p>
          <button
            type="button"
            onClick={reset}
            style={{
              height: 38,
              padding: "0 16px",
              borderRadius: 9,
              border: "none",
              background: "#623cff",
              color: "#ffffff",
              fontSize: 12,
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            Reload
          </button>
        </div>
      </body>
    </html>
  );
}
